
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/wgs/site/[siteId]",
      function () {
        return require("private-next-pages/wgs/site/[siteId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/wgs/site/[siteId]"])
      });
    }
  